import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';

import { FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedDataService } from '@teem/services/shared-data.service';
import { messages as i18n } from "@teem/constants/messages";

@Component({
  selector: 'app-add-items',
  templateUrl: './add-items.component.html',
  styleUrls: ['./add-items.component.scss']
})
export class AddItemsComponent implements OnInit {
  @Input() formId: string;
  @Input() form: FormGroup;
  @Input() formType: string;
  @Output() onSubmit: EventEmitter<FormGroup> = new EventEmitter();
  @Output() onCancel: EventEmitter<any> = new EventEmitter();
  @ViewChild('formRef') formRef: FormGroupDirective;
  isSubmitted: boolean = false;
  oldValues: any;
  basicInfo: any;
  itemTitle: string = i18n.invoice.add_new_item; //'Add New Item';

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private sharedDataService: SharedDataService,
    private el: ElementRef
  ) {
  }


  ngOnInit(): void {
    this.basicInfo = (window as any).userInfo;

    // Show/Hide whatsapp action as per pro plan
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.userInfo) {
        this.basicInfo = data.userInfo;
      }
    })

    this.oldValues = Object.assign({}, this.form.value);
    if (this.formType == "addNew") {
      this.itemTitle = i18n.invoice.add_new_item;
    } else {
      this.itemTitle = i18n.invoice.update_item;
    }
  }

  get isProPlan() {
    return this.basicInfo && this.basicInfo.subscription && this.basicInfo.subscription.subscription_plan == 'pro';
  }

  submit() {
    this.isSubmitted = true;
    if (this.form.valid) {
      // if(!this.isProPlan){
      //   this.form.get('add_to_store').setValue(false);
      // }
      this.onSubmit.emit(this.form);
      if (this.formType == "addNew") {
        this.form.reset({});
        this.form.get('quantity').setValue(1);
      }

      this.isSubmitted = false;
      this.activeModal.dismiss()
    } else {
      console.log("error");
    }
  }

  cancel() {
    this.form.reset(this.oldValues);
    this.onCancel.emit(this.form);
  }

}
